import { render, staticRenderFns } from "./DocumentVerificationModal.vue?vue&type=template&id=282c2d64&"
import script from "./DocumentVerificationModal.vue?vue&type=script&lang=js&"
export * from "./DocumentVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports